import { render, staticRenderFns } from "./FavOverview.vue?vue&type=template&id=b647a46c&"
import script from "./FavOverview.vue?vue&type=script&lang=js&"
export * from "./FavOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports